import type { GeolocationCountryInterface } from '~/diptyqueTheme/stores/countries/types';

export const externalStoreUrl = process.env.EXTERNAL_STORE_URL;

// todo fill with correct store names*
//  *they must match the keys in the translation files
export const redirectConfig: Record<string, GeolocationCountryInterface> = {
  default: { store: 'International', redirectTo: 'en_eu' },
  US: {
    store: 'United States',
    redirectTo: 'en_us',
    availableStores: ['en_us', 'fr_us']
  },
  CA: {
    store: 'United States',
    redirectTo: 'en_us',
    availableStores: ['en_us', 'fr_us']
  },
  FR: { store: 'France', redirectTo: 'fr_fr' },
  GB: { store: 'United Kingdom', redirectTo: 'en_uk' },
  ES: { store: 'Spain', redirectTo: 'es_eu' },
  DE: { store: 'Germany', redirectTo: 'de_eu' },
  IT: { store: 'Italy', redirectTo: 'it_eu' },
  CN: { store: 'China', redirectTo: 'zh_hk' },
  HK: { store: 'Hong Kong', redirectTo: 'en_hk' },
  JP: { store: 'Japan', redirectTo: 'ja_jp' },
  AT: { store: 'Germany', redirectTo: 'de_eu' },
  BE: { store: 'Belgium', redirectTo: externalStoreUrl, isExternalUrl: true },
  NL: { store: 'Netherlands', redirectTo: externalStoreUrl, isExternalUrl: true },
  PL: { store: 'Poland', redirectTo: externalStoreUrl, isExternalUrl: true },
  AL: { store: 'Albania', redirectTo: externalStoreUrl, isExternalUrl: true },
  AM: { store: 'Armenia', redirectTo: externalStoreUrl, isExternalUrl: true },
  GF: { store: 'French Guiana', redirectTo: externalStoreUrl, isExternalUrl: true },
  PF: { store: 'French Polynesia', redirectTo: externalStoreUrl, isExternalUrl: true },
  GI: { store: 'Gibraltar', redirectTo: externalStoreUrl, isExternalUrl: true },
  GP: { store: 'Guadeloupe', redirectTo: externalStoreUrl, isExternalUrl: true },
  IS: { store: 'Iceland', redirectTo: externalStoreUrl, isExternalUrl: true },
  MT: { store: 'Malta', redirectTo: externalStoreUrl, isExternalUrl: true },
  MQ: { store: 'Martinique', redirectTo: externalStoreUrl, isExternalUrl: true },
  YT: { store: 'Mayotte', redirectTo: externalStoreUrl, isExternalUrl: true },
  MD: { store: 'Moldova', redirectTo: externalStoreUrl, isExternalUrl: true },
  MA: { store: 'Morocco', redirectTo: externalStoreUrl, isExternalUrl: true },
  NO: { store: 'Norway', redirectTo: externalStoreUrl, isExternalUrl: true },
  NC: { store: 'New Caledonia', redirectTo: externalStoreUrl, isExternalUrl: true },
  OM: { store: 'Oman', redirectTo: externalStoreUrl, isExternalUrl: true },
  RE: { store: 'Reunion', redirectTo: externalStoreUrl, isExternalUrl: true },
  BL: { store: 'Saint Barthelemy', redirectTo: externalStoreUrl, isExternalUrl: true },
  MF: { store: 'Saint Martin', redirectTo: externalStoreUrl, isExternalUrl: true },
  RS: { store: 'Serbia', redirectTo: externalStoreUrl, isExternalUrl: true },
  ZA: { store: 'South Africa', redirectTo: externalStoreUrl, isExternalUrl: true },
  CH: { store: 'Switzerland', redirectTo: externalStoreUrl, isExternalUrl: true },
  WF: { store: 'Wallis & Futuna', redirectTo: externalStoreUrl, isExternalUrl: true },

  // South America
  AR: { store: 'United States', redirectTo: 'en_us' },
  BO: { store: 'United States', redirectTo: 'en_us' },
  BR: { store: 'United States', redirectTo: 'en_us' },
  CL: { store: 'United States', redirectTo: 'en_us' },
  CO: { store: 'United States', redirectTo: 'en_us' },
  EC: { store: 'United States', redirectTo: 'en_us' },
  GY: { store: 'United States', redirectTo: 'en_us' },
  PY: { store: 'United States', redirectTo: 'en_us' },
  PE: { store: 'United States', redirectTo: 'en_us' },
  SR: { store: 'United States', redirectTo: 'en_us' },
  UY: { store: 'United States', redirectTo: 'en_us' },
  VE: { store: 'United States', redirectTo: 'en_us' },

  // Caribbean
  AG: { store: 'United States', redirectTo: 'en_us' },
  BS: { store: 'United States', redirectTo: 'en_us' },
  BB: { store: 'United States', redirectTo: 'en_us' },
  CU: { store: 'United States', redirectTo: 'en_us' },
  DM: { store: 'United States', redirectTo: 'en_us' },
  DO: { store: 'United States', redirectTo: 'en_us' },
  GD: { store: 'United States', redirectTo: 'en_us' },
  HT: { store: 'United States', redirectTo: 'en_us' },
  JM: { store: 'United States', redirectTo: 'en_us' },
  KN: { store: 'United States', redirectTo: 'en_us' },
  LC: { store: 'United States', redirectTo: 'en_us' },
  VC: { store: 'United States', redirectTo: 'en_us' },
  TT: { store: 'United States', redirectTo: 'en_us' },

  // Central America
  BZ: { store: 'United States', redirectTo: 'en_us' },
  CR: { store: 'United States', redirectTo: 'en_us' },
  SV: { store: 'United States', redirectTo: 'en_us' },
  GT: { store: 'United States', redirectTo: 'en_us' },
  HN: { store: 'United States', redirectTo: 'en_us' },
  NI: { store: 'United States', redirectTo: 'en_us' },
  PA: { store: 'United States', redirectTo: 'en_us' },

  // Mexico
  MX: { store: 'United States', redirectTo: 'en_us' }
};
